import { create } from 'zustand';
import { adminReportsApi } from '@api/api-config.ts';
import { AdminReportResponse } from '@api/generated/portal-be-admin';

export interface AdminReportFilter {
  /** Část kódu nebo názvu reportu. */
  q?: string;
}

interface AdminReportStoreState {
  loading: boolean;
  error: string | null;
  data: AdminReportResponse[] | null;

  /** Poslední použitý filtr — po uložení v dialogu se seznam načte znovu se stejným rozsahem. */
  filter: AdminReportFilter;

  loadReports: (filter: AdminReportFilter) => Promise<void>;
  reloadReports: () => Promise<void>;
}

/**
 * Katalog reportů. Bez stránkování — reportů je řádově desítky a backend vrací celý seznam.
 */
export const useAdminReportStore = create<AdminReportStoreState>((set, get) => ({
  loading: false,
  error: null,
  data: null,
  filter: {},

  loadReports: async (filter: AdminReportFilter) => {
    try {
      set({ loading: true, error: null, filter });
      const response = await adminReportsApi.getAdminReports({ q: filter.q });
      set({ loading: false, error: null, data: response.data });
    } catch (error) {
      set({ loading: false, error: error instanceof Error ? error.message : 'Chyba při načítání reportů' });
    }
  },

  reloadReports: async () => {
    await get().loadReports(get().filter);
  },
}));
